import { create } from "zustand";

import { useChatStore } from "./use-chat-store";

interface IChatInputState {
  handleInputKeyDown: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  handlePrompt: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  handleSubmit: () => void;
  input: string;
  setInput: (input: string) => void;
}

const useChatInputStore = create<IChatInputState>(
  (set, get): IChatInputState => ({
    handleInputKeyDown: (
      event: React.KeyboardEvent<HTMLTextAreaElement>,
    ): void => {
      if (event.key === "Enter" && !event.shiftKey) {
        event.preventDefault();
        get().handleSubmit();
      }
    },
    handlePrompt: (event: React.ChangeEvent<HTMLTextAreaElement>): void => {
      set({ input: event.target.value });
    },
    handleSubmit: (): void => {
      const { input } = get();
      const { setPrompt } = useChatStore.getState();
      setPrompt(input);
      set({ input: "" });
    },
    input: "",
    setInput: (input: string): void => {
      set({ input });
    },
  }),
);

export { useChatInputStore };
